import React from 'react';
import { ButtonProps } from 'semantic-ui-react';
import { Button } from '@modules/common/components/buttons/Button';

const ActionButton = ({ loading, disabled, onClick, ...rest }: ButtonProps) => {
  const handleClick = loading || disabled ? undefined : onClick;

  return (
    <Button
      type="submit"
      aria-label="submit-button"
      {...rest}
      onClick={handleClick}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default ActionButton;
